var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c("div", { attrs: { id: "subheader" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "main-container" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c("div", { attrs: { id: "header-pedido" } }, [
            _c(
              "div",
              {
                staticClass: "fh rc",
                staticStyle: { width: "100%", height: "100%" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh cb",
                    staticStyle: {
                      "font-size": "13px",
                      color: "#5D6770",
                      "margin-right": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "Subtotal: " +
                        _vm._s(_vm.moneyLabel) +
                        " " +
                        _vm._s(_vm._f("formatMoney")(_vm.subtotal)) +
                        " "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cb",
                    staticStyle: {
                      "font-size": "16px",
                      color: "#5D6770",
                      "margin-right": "36px",
                      "font-weight": "500"
                    }
                  },
                  [
                    _vm._v(
                      "Total: " +
                        _vm._s(_vm.moneyLabel) +
                        " " +
                        _vm._s(_vm._f("formatMoney")(_vm.total)) +
                        " "
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "list-container" } },
            _vm._l(_vm.items, function(item) {
              return _c("item-pedido", {
                attrs: { id: "list-prod", item: item },
                on: { eliminarItem: _vm.btnEliminarItem }
              })
            })
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "btnContainer" } }, [
            _c("input", {
              attrs: { id: "btnEliminar", type: "submit", value: "ELIMINAR" },
              on: { click: _vm.btnEliminar }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { id: "btnGuardar", type: "submit", value: "GUARDAR" },
              on: { click: _vm.btnGuardar }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                id: "btnAgregar",
                type: "submit",
                value: "AGREGAR ITEM"
              },
              on: { click: _vm.btnAgregar }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                id: "btnAgregar",
                type: "submit",
                value: "AGREGAR PROMO"
              },
              on: { click: _vm.btnAgregarPromo }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { id: "btnEnviar", type: "submit", value: "ENVIAR" },
              on: { click: _vm.btnEnviar }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPopup,
                expression: "showPopup"
              }
            ],
            attrs: { showPopup: _vm.showPopup }
          },
          [
            _c("div", { attrs: { id: "back-popup" } }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "popup-envio-pedido" } },
              [
                _c("div", { attrs: { id: "popup-btnClose-container" } }, [
                  _c("img", {
                    staticStyle: { width: "20px", height: "20px" },
                    attrs: { id: "btnClose", src: "/dist/btnClose.png" },
                    on: { click: _vm.btnCerrarPopup }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { id: "popup-titulo" }
                  },
                  [_vm._v("Enviar Pedido")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "labelsForms" }, [
                  _vm._v("Condición de venta")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.condicionVenta,
                        expression: "condicionVenta"
                      }
                    ],
                    staticClass: "wc",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.condicionVenta = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.condicionesVenta, function(option) {
                    return _c("option", { domProps: { value: option } }, [
                      _vm._v(_vm._s(option.Nombre))
                    ])
                  })
                ),
                _vm._v(" "),
                _c("div", { staticClass: "labelsForms" }, [
                  _vm._v("Fecha de despacho")
                ]),
                _vm._v(" "),
                _c("datepicker", {
                  attrs: {
                    "wrapper-class": "wc",
                    "input-class": "datepicker-ic",
                    disabledDates: _vm.disabledDates,
                    language: _vm.es
                  },
                  model: {
                    value: _vm.calendario,
                    callback: function($$v) {
                      _vm.calendario = $$v
                    },
                    expression: "calendario"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "labelsForms" }, [
                  _vm._v("Sucursal de entrega")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sucursal,
                        expression: "sucursal"
                      }
                    ],
                    staticClass: "wc",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.sucursal = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.sucursales, function(option) {
                    return _c("option", { domProps: { value: option } }, [
                      _vm._v(_vm._s(option.Nombre))
                    ])
                  })
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showEnviaCopiaPedido,
                        expression: "showEnviaCopiaPedido"
                      }
                    ],
                    staticClass: "labelsForms"
                  },
                  [_vm._v("Enviar copia del pedido")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.contacto,
                        expression: "contacto"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showEnviaCopiaPedido,
                        expression: "showEnviaCopiaPedido"
                      }
                    ],
                    staticClass: "wc",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.contacto = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.contactos, function(option) {
                    return _c("option", { domProps: { value: option } }, [
                      _vm._v(_vm._s(option.Contacto))
                    ])
                  })
                ),
                _vm._v(" "),
                _c("div", { staticClass: "labelsForms" }, [
                  _vm._v("Orden de compra")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ordenCompra,
                      expression: "ordenCompra"
                    }
                  ],
                  staticClass: "wc",
                  staticStyle: { "margin-left": "30px" },
                  domProps: { value: _vm.ordenCompra },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.ordenCompra = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      labelsForms: _vm.lengthObsFact,
                      labelsFormsInv: !_vm.lengthObsFact
                    }
                  },
                  [
                    _vm._v(
                      "Observaciones Facturación " +
                        _vm._s(_vm.observacionesFacturacionCount)
                    )
                  ]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.observacionesFacturacion,
                      expression: "observacionesFacturacion"
                    }
                  ],
                  staticStyle: { height: "20px" },
                  attrs: { id: "obs" },
                  domProps: { value: _vm.observacionesFacturacion },
                  on: {
                    keyup: _vm.onKeyDownHandler,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.observacionesFacturacion = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      labelsForms: _vm.lengthObsPlanta,
                      labelsFormsInv: !_vm.lengthObsPlanta
                    }
                  },
                  [
                    _vm._v(
                      "Observaciones Planta " +
                        _vm._s(_vm.observacionesPlantaCount)
                    )
                  ]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.observacionesPlanta,
                      expression: "observacionesPlanta"
                    }
                  ],
                  staticStyle: { height: "20px" },
                  attrs: { id: "obs" },
                  domProps: { value: _vm.observacionesPlanta },
                  on: {
                    keyup: _vm.onKeyDownHandler,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.observacionesPlanta = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { attrs: { id: "btnContainerPopup" } }, [
                  _c(
                    "button",
                    {
                      attrs: { id: "btnclose" },
                      on: { click: _vm.btnCerrarPopup }
                    },
                    [_vm._v("CANCELAR")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { id: "btnsend" },
                      on: { click: _vm.btnEnviarPopup }
                    },
                    [_vm._v("ENVIAR")]
                  )
                ])
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Carrito de Compras")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1983740e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1983740e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/pedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1983740e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/pedido.vue
// module chunks = 0